import React, { useState } from 'react';
import randomForestIcon from '../assets/random-forest.png';
import svmIcon from '../assets/support-vector-machine.png';
import neuralNetworkIcon from '../assets/nueral-network.png';
import gradientBoostingIcon from '../assets/gradient-boosting.png';

export type MLAlgorithm = 'random forest' | 'support vector' | 'neural network' | 'gradient boosting';

interface AlgorithmOption {
  id: MLAlgorithm;
  title: string;
  description: string;
  image: string;
  note?: string;
  disabled?: boolean;
}

interface AlgorithmProps {
  onBack: () => void;
  onNext: (algorithm: MLAlgorithm) => void;
}

export const Algorithm: React.FC<AlgorithmProps> = ({ onBack, onNext }) => {
  const [selectedAlgorithm, setSelectedAlgorithm] = useState<MLAlgorithm | null>(null);

  const algorithms: AlgorithmOption[] = [
    {
      id: 'random forest',
      title: 'Random Forest',
      description: 'An ensemble of decision trees that generates predictions by computing the average of the outputs from all individual trees.',
      image: randomForestIcon,
    },
    {
      id: 'support vector',
      title: 'Support Vector Machine',
      description: 'A model that fits a kernel function in N-dimensional space to generate prediction.',
      image: svmIcon,
    },
    {
      id: 'neural network',
      title: 'Neural Network',
      description: 'A deep learning method composed of layered nodes that generates predictions.',
      image: neuralNetworkIcon,
      note: 'Try after other methods like rf and svm',
    },
    {
      id: 'gradient boosting',
      title: 'Gradient Boosting',
      description: 'Sequential ensemble method with high accuracy',
      image: gradientBoostingIcon,
      disabled: true,
    },
  ];

  const handleAlgorithmSelect = (algorithmId: MLAlgorithm, disabled?: boolean) => {
    if (disabled) return;
    setSelectedAlgorithm(algorithmId);
  };

  const handleContinue = () => {
    if (selectedAlgorithm) {
      onNext(selectedAlgorithm);
    }
  };

  return (
    <div className="wizard-step-container">
      <div className="wizard-step-header">
        <button className="back-button" onClick={onBack}>
          <span className="back-arrow">←</span> Back
        </button>
        <h1>Select ML Algorithm</h1>
      </div>

      <div className="algorithm-options">
        {algorithms.map((algorithm) => (
          <div
            key={algorithm.id}
            className={`algorithm-card ${selectedAlgorithm === algorithm.id ? 'selected' : ''} ${algorithm.disabled ? 'disabled' : ''}`}
            onClick={() => handleAlgorithmSelect(algorithm.id, algorithm.disabled)}
          >
            <div className="algorithm-icon">
              <img src={algorithm.image} alt={algorithm.title} />
            </div>
            <div className="algorithm-content">
              <h3>{algorithm.title}</h3>
              <p>{algorithm.description}</p>
              {algorithm.note && (
                <p className="algorithm-note">
                  <strong>Note:</strong> {algorithm.note}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      <button
        className="btn btn-primary continue-btn-full"
        onClick={handleContinue}
        disabled={!selectedAlgorithm}
      >
        Continue
        <span className="arrow-right">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M4.16699 10H15.8337M15.8337 10L10.0003 4.16669M15.8337 10L10.0003 15.8334" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      </button>
    </div>
  );
};

